import React from 'react';

import { ImmutableEntity, OptionalArrayField, ReferenceField } from '@uncinc/react-drupal-core/types';
import TaxonomyThemeTeaser from './Teaser';
import TaxonomyThemeOverviewTeaser from './OverviewTeaser';
import TaxonomyThemePage from './Page';
import TaxonomyThemeParentPage from './ParentPage';
import { TaxonomyThemes } from '../../../types/uncinc_profile/taxonomy';

interface TaxonomyThemeProps {
  entity: ImmutableEntity<TaxonomyThemes>;
  viewMode: string;
  classes: string;
  childThemes: OptionalArrayField<[ImmutableEntity<TaxonomyThemes>]>;
}

const TaxonomyThemeWrapper: React.FC<TaxonomyThemeProps> = ({
  entity, viewMode, classes = '', childThemes,
}) => {
  const hasParentId = entity.getIn(['parent', 0, 'target_id'], null);

  switch (viewMode) {
    case 'teaser':
      return <TaxonomyThemeTeaser entity={entity} classes={classes} />;
    case 'overview_teaser':
      return (
        <TaxonomyThemeOverviewTeaser
          entity={entity}
          classes={classes}
          childThemes={childThemes}
        />
      );
    default:
      return hasParentId
        ? <TaxonomyThemePage entity={entity} />
        : <TaxonomyThemeParentPage entity={entity} />;
  }
};

export default TaxonomyThemeWrapper;
